import { defineComponent as _defineComponent } from 'vue'
import { useCustomerStore } from '@/store/customer';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'B2BSwitch',
  setup(__props) {

    const customerStore = useCustomerStore();

    function changeCustomerStatus() {
        customerStore.customer.is_company = !customerStore.customer.is_company;
    }

return { __sfc: true,customerStore, changeCustomerStatus }
}

})